import _ from 'lodash';
import { resolveLocalizedText } from '../../../utils';

const emmaAktivoOnboardingModuleName = `aktivo-onboarding`;

export const getMyWellnessRulesInfo = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${emmaAktivoOnboardingModuleName}.rules.myWellness`,
    {},
  );
};

export const getTrackerConnectSuccessInfo = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${emmaAktivoOnboardingModuleName}.trackerConnectSuccess`,
    {},
  );
};

export const getDisclaimerInfoApiUrl = (state: {}): any => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${emmaAktivoOnboardingModuleName}.disclaimerInfoPath`,
    '',
  );
};

export const getEmmaAppDownloadPath = (state: {}): any => {
  const link = _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.${emmaAktivoOnboardingModuleName}.emmaAppPath`,
    '',
  );
  return resolveLocalizedText(link);
};

export const getAktivoOnboardingConfig = (state: {}): any => {
  return _.get(state, `hk-emma-web-core/aktivo.aktivo`, {});
};

export const getAktivoDisclaimerCustState = (state: {}): any => {
  return _.get(state, `hk-emma-web-core/aktivo.aktivo.disclaimerCustState`, {});
};

// export const getAxaGoalInsuredPolicies = (state: {}): any => {
//   const dashboardPolicies: any = _.get(
//     state,
//     `hk-emma-web-core/user.customer.policies`,
//     [],
//   );
//   return dashboardPolicies.filter(
//     (p: any) =>
//       (p.isOwnIsuredFlag === 'Y' ||
//         (p.isInsuredFlag === 'Y' && p.isOwnIsuredFlag !== 'Y')) && // is only-insured / OWN-INS
//       p.axaGoalPolicy === 'Y',
//   );
// };

// export const getIsAgreedTnc = (state: {}): any => {
//   const policies = getAxaGoalInsuredPolicies(state);
//   const custState = getAktivoDisclaimerCustState(state);
//   if (!custState.isAcceptedAktivoTnc) {
//     return false;
//   }
//   for (const policy of policies) {
//     const foundPolicy = custState.policies.find(
//       (p: any) => p.policyNumber === policy.policyNumber,
//     );
//     if (!foundPolicy) {
//       return false;
//     }
//     if (
//       !foundPolicy.isAcceptedAxaGoalTnc &&
//       !foundPolicy.isAcceptedSilverHairTnc
//     ) {
//       return false;
//     }
//   }
//   return true;
// };
